// useStackedPersistentState.js
import {useCallback, useEffect, useState} from 'react';

const getInitialStackedState = () => {
  try {
    const saved = localStorage.getItem("stackedViewState");
    if (saved) {
      const parsed = JSON.parse(saved);
      return {
        expandedProjects: parsed.expandedProjects || {},
        expandedTasks: parsed.expandedTasks || {},
        activeTabByJob: parsed.activeTabByJob || {},
        assigneeFilters: parsed.assigneeFilters || {},
        expandedWorkspaces: parsed.expandedWorkspaces || {},   // NEW
      };
    }
  } catch (e) {
    console.error("Failed to load stacked view state", e);
  }
  return {
    expandedProjects: {},
    expandedTasks: {},
    activeTabByJob: {},
    assigneeFilters: {},
    expandedWorkspaces: {},   // NEW
  };
};

export const useStackedPersistentState = () => {
  const [stackedState, setStackedState] = useState(getInitialStackedState);

  useEffect(() => {
    try {
      localStorage.setItem("stackedViewState", JSON.stringify(stackedState));
    } catch (e) {
      console.error("Failed to save stacked view state", e);
    }
  }, [stackedState]);

  const setExpandedProjects = useCallback((valueOrUpdater) => {
    setStackedState((prev) => ({
      ...prev,
      expandedProjects:
        typeof valueOrUpdater === "function"
          ? valueOrUpdater(prev.expandedProjects)
          : valueOrUpdater,
    }));
  }, []);

  const setExpandedTasks = useCallback((valueOrUpdater) => {
    setStackedState((prev) => ({
      ...prev,
      expandedTasks:
        typeof valueOrUpdater === "function"
          ? valueOrUpdater(prev.expandedTasks)
          : valueOrUpdater,
    }));
  }, []);

  const setActiveTabByJob = useCallback((valueOrUpdater) => {
    setStackedState((prev) => ({
      ...prev,
      activeTabByJob:
        typeof valueOrUpdater === "function"
          ? valueOrUpdater(prev.activeTabByJob)
          : valueOrUpdater,
    }));
  }, []);

  const setAssigneeFilters = useCallback((valueOrUpdater) => {
    setStackedState((prev) => ({
      ...prev,
      assigneeFilters:
        typeof valueOrUpdater === "function"
          ? valueOrUpdater(prev.assigneeFilters)
          : valueOrUpdater,
    }));
  }, []);

  // NEW setter for expandedWorkspaces
  const setExpandedWorkspaces = useCallback((valueOrUpdater) => {
    setStackedState((prev) => ({
      ...prev,
      expandedWorkspaces:
        typeof valueOrUpdater === "function"
          ? valueOrUpdater(prev.expandedWorkspaces)
          : valueOrUpdater,
    }));
  }, []);

  return {
    stackedState,
    setStackedState,
    setExpandedProjects,
    setExpandedTasks,
    setActiveTabByJob,
    setAssigneeFilters,
    setExpandedWorkspaces,   // NEW
  };
};